export default "__VITE_ASSET__DPn_1blv__"